import { render } from "./AddEditOrderModalDialog.vue?vue&type=template&id=71e60720&scoped=true&ts=true&lang=pug"
import script from "./AddEditOrderModalDialog.vue?vue&type=script&lang=ts"
export * from "./AddEditOrderModalDialog.vue?vue&type=script&lang=ts"

import "./AddEditOrderModalDialog.vue?vue&type=style&index=0&id=71e60720&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e60720"]])

export default __exports__